import * as React from 'react';
import { Helmet } from 'react-helmet';

import PaymentProcessorTypes from 'bundles/payments-common/common/PaymentProcessorTypes';
import SubscriptionStatus from 'bundles/subscriptions-common/utils/SubscriptionStatus';
import { useGetLoggedInUserSubscriptions } from 'bundles/subscriptions-common/utils/useGetLoggedInUserSubscriptions';

const INC_PUBLIC_KEY = '2435bb50613be2bf5ec53a0e2ab0fa62';
const BV_PUBLIC_KEY = '0f4319f5eadc146672e40079c89973cb';

type ProfitwellTagProps = {
  processor?: string;
  userEmail?: string;
};

const ProfitwellTag = ({ processor, userEmail }: ProfitwellTagProps) => {
  const { subscriptions } = useGetLoggedInUserSubscriptions({});
  // If processor is present, load marketing script for logged-out user
  if (processor) {
    let pwKey;
    if (processor === 'stripe') {
      pwKey = INC_PUBLIC_KEY;
    } else if (processor === 'stripe_bv') {
      pwKey = BV_PUBLIC_KEY;
    } else {
      return null;
    }

    return (
      <Helmet>
        <script id="profitwell-js" data-pw-auth={pwKey}>
          {
            /* DO NOT DELETE - this code is used to accept our payments or send data to ProfitWell */
            `(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
    a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
    s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
    })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');

    profitwell('start', {});`
          }
        </script>
      </Helmet>
    );
  }

  // If user is logged in, load script with user email
  if (userEmail) {
    const paymentProcessorIds = subscriptions
      ?.filter((subscription) => subscription.status === SubscriptionStatus.PAST_DUE)
      .map((subscription) => subscription.paymentProcessorId);

    // Profitwell script only support one payment processor id at a time, so we use the first one
    const paymentProcessorId = paymentProcessorIds?.[0];
    let pwKey;
    if (paymentProcessorId === PaymentProcessorTypes.stripeConsumer) {
      pwKey = INC_PUBLIC_KEY;
    } else if (paymentProcessorId === PaymentProcessorTypes.stripeBvConsumer) {
      pwKey = BV_PUBLIC_KEY;
    } else {
      return null;
    }

    return (
      <Helmet>
        <script id="profitwell-js" data-pw-auth={pwKey}>
          {
            /* DO NOT DELETE - this code is used to accept our payments or send data to ProfitWell */
            `(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
    a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
    s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
    })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');

    profitwell('start', { 'user_email': ${JSON.stringify(userEmail)} });`
          }
        </script>
      </Helmet>
    );
  }

  return null;
};

export default ProfitwellTag;
